import React, { useCallback, useEffect, useRef, useState } from "react";
import { SERVICES } from "../../../core/services/services";
import { CustomModal } from "../../../shared/components/custom-modal/custom-modal";
import { Toast } from "primereact/toast";
import { HELPER } from "../../../shared/helper/helper";
import ErrorBoundary from "../../../shared/components/error-boundary/error-boundary";
import { Optional } from "../../../shared/components/optional/optional";
import { BACKOFFICE_API } from "../../../core/apis/backoffice-apis";
import { MandateConfigurationUpdateForm } from "./mandate-configuration-update-form";
import { TabPanel, TabView } from "primereact/tabview";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import { FRONTOFFICE_API } from "../../../core/apis/frontoffice-apis";
import { UserTypes } from "../../../shared/constants";

export function DebitMandateConfigurations(props) {
  const toast = useRef(null);
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentModalIndex, setCurrentModalIndex] = useState(0);
  const [debitMandateConfigurations, setDebitMandateConfigurations] = useState(
    []
  );
  const [loading, setLoading] = useState(false);

  const handleSuccess = useCallback((data) => {
    const result = data?.result;

    setDebitMandateConfigurations(result);
    setLoading(false);
  }, []);

  const getDebitMandateConfigurations = useCallback(() => {
    setLoading(true);
    setDebitMandateConfigurations(null);
    const backofficeUrl = `${BACKOFFICE_API.DEBIT_MANDATES}/global-config/default`;
    const frontofficeUrl = `${FRONTOFFICE_API.DEBIT_MANDATES}/global-config/default`;
    const url =
      props.userType === UserTypes.Frontoffice ? frontofficeUrl : backofficeUrl;
    SERVICES.MAKE_GET_REQUEST(url)
      .then((data) => {
        handleSuccess(data, false);
      })
      .catch((error) => {
        // setError(HELPER.PROCESS_ERROR(error));
        toast.current.show({
          severity: "error",
          summary: "Error getting mandate configurations!",
          detail: HELPER.PROCESS_ERROR(error, "TOAST"),
          life: 10000,
        });
        setLoading(false);
      });
  }, [handleSuccess, props.userType]);

  useEffect(() => {
    getDebitMandateConfigurations();
  }, [getDebitMandateConfigurations]);

  function onHide() {}

  function openModal(index) {
    setCurrentModalIndex(index);
    setVisible(true);
  }

  function closeModal(refresh) {
    if (refresh) {
      getDebitMandateConfigurations();
    }
    if (visible) {
      setVisible(false);
    }
    if (currentIndex === 2) {
      setCurrentIndex(1);
    }
  }

  const modalContent = () => {
    // eslint-disable-next-line default-case
    switch (currentModalIndex) {
      case 0:
        return (
          <MandateConfigurationUpdateForm
            closeModal={closeModal}
            mandateConfiguration={debitMandateConfigurations}
            // verificationLimit={selectedVerificationLimit}
          />
        );
    }
  };

  return (
    <ErrorBoundary>
      <div>
        <Toast ref={toast} />
        <div>
          <CustomModal
            closeModal={closeModal}
            onHide={onHide}
            visible={visible}
            modalContent={modalContent}
          />
        </div>
        <div
          style={{ backgroundColor: "#ffffff", paddingTop: "1em" }}
          className="p-shadow-1 p-pb-5"
        >
          <TabView>
            <TabPanel header="Mandate Configurations">
              <div className="p-text-left" style={{ marginBottom: "10rem" }}>
                {!loading ? (
                  <>
                    <div className="p-grid p-mt-2">
                      <div className="p-col-8" />
                      <div className="p-col-4">
                        <Optional
                          show={HELPER.HAS_AUTHORITY(
                            "bo_setup_global_debit_mandate_config"
                          )}
                        >
                          <div
                            style={{
                              width: "135px",
                              float: "right",
                            }}
                          >
                            <button
                              onClick={() => openModal(0)}
                              className="primary-button"
                            >
                              Update
                            </button>
                          </div>
                        </Optional>
                      </div>
                    </div>
                    <div className="centralize p-mt-5">
                      <div className="p-grid dcir-row">
                        <div className="p-col-6">
                          <p className="details-label">
                            Max Allowed Debit Amount:
                          </p>
                        </div>
                        <div className="p-col-6">
                          <p className="details-value">
                            {HELPER.TRANSFORM_VIEW(
                              "maxAllowedDebitAmount",
                              debitMandateConfigurations?.maxAllowedDebitAmount
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="p-grid dcir-row">
                        <div className="p-col-6">
                          <p className="details-label">
                            Max Allowed Single Debit Amount:
                          </p>
                        </div>
                        <div className="p-col-6">
                          <p className="details-value">
                            {HELPER.TRANSFORM_VIEW(
                              "maxAllowedSingleDebitAmount",
                              debitMandateConfigurations?.maxAllowedSingleDebitAmount
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="p-grid dcir-row">
                        <div className="p-col-6">
                          <p className="details-label">
                            Max Allowed Debit Count:
                          </p>
                        </div>
                        <div className="p-col-6">
                          <p className="details-value">
                            {HELPER.TRANSFORM_VIEW(
                              "maxAllowedDebitCount",
                              debitMandateConfigurations?.maxAllowedDebitCount
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="p-grid dcir-row">
                        <div className="p-col-6">
                          <p className="details-label">
                            Max Allowed Duration In Days:
                          </p>
                        </div>
                        <div className="p-col-6">
                          <p className="details-value">
                            {
                              // HELPER.TRANSFORM_VIEW(
                              //   "maxAllowedDebitCount",
                              debitMandateConfigurations?.maximumDurationInDays
                              // maxAllowedDurationInDays
                              // )
                            }
                          </p>
                        </div>
                      </div>

                      <div className="p-grid dcir-row">
                        <div className="p-col-6">
                          <p className="details-label">
                            Maximum Mandate Per Merchant Per Account:
                          </p>
                        </div>
                        <div className="p-col-6">
                          <p className="details-value">
                            {
                              debitMandateConfigurations?.maxMandatePerMerchantPerAccount
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="p-text-center p-mt-5">
                    <CustomLoader loadingText="Loading..." />
                  </div>
                )}
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </ErrorBoundary>
  );
}
